export default __webpack_public_path__ + "static/media/disable-gray.69ce466b.svg";